export default {
  signal: 'Signál',
  unit: 'Jednotka',
  min: 'Min',
  max: 'Max',
  average: 'ȳ',
  standardDeviation: 'σ',
  cursor: 'kurzor',
};
